import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export function formatApiError(e, fallback = "Si è verificato un errore. Riprova.") {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || "").filter(Boolean).join(" ");
  return fallback;
}

export const CATEGORY_LABELS = {
  domestiche: "Domestiche",
  industriali: "Industriali",
  ricamo: "Ricamo e Tagliacuci",
};

export const CATEGORY_BADGE = {
  domestiche: "bg-sky-50 text-sky-700 border border-sky-200/60",
  industriali: "bg-slate-100 text-slate-800 border border-slate-300/60",
  ricamo: "bg-amber-50 text-amber-800 border border-amber-200/60",
};

export const ORDER_STATUS_LABELS = {
  da_contattare: "Da Contattare",
  contattato: "Contattato",
  confermato: "Confermato",
  annullato: "Annullato",
};

export const ORDER_STATUS_BADGE = {
  da_contattare: "bg-amber-50 text-amber-700 border border-amber-200",
  contattato: "bg-sky-50 text-sky-700 border border-sky-200",
  confermato: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  annullato: "bg-rose-50 text-rose-700 border border-rose-200",
};

export function stockBadge(stock) {
  if (stock <= 0) return { label: "Esaurita", cls: "bg-rose-50 text-rose-700 border border-rose-200" };
  if (stock <= 2) return { label: `Ultime ${stock} disponibili`, cls: "bg-amber-50 text-amber-700 border border-amber-200" };
  return { label: "Disponibile", cls: "bg-emerald-50 text-emerald-700 border border-emerald-200" };
}

export function formatPrice(price) {
  return new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(price || 0);
}
